import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';
import { UserDataService } from '../features/user-data.service';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  isLogged=true;
  isLoading=false;
  error="";
  email="";
  password="";
  isFormValid=false;
  isMailValid=false;

  constructor(private auth:AuthService, private router:Router, private user:UserDataService) {

  }
  onSwitchMode() {this.isLogged=!this.isLogged}
  onSubmit(form:NgForm) {
    this.isLoading=true;
    const email:string=form.value.email;
    const password:string= form.value.password;

    this.auth.logIn(email,password).subscribe(res=>{
     // console.log(res);
      this.isLoading=false;
      this.router.navigate(["/patentList"]);//Carefullll


    },err=>{console.log(err);this.isLoading=false;
    this.error=err;

    });
    form.reset();

   }
   changePassword(form:NgForm) {
    //console.log("umut");
    this.isLoading=true;
    const email:string=form.value.email;


    this.auth.changePassword(email).subscribe(res=>{
      //console.log(res);
      this.isLoading=false;
      //this.router.navigate(["/patentList"]);//Carefullll
      this.error="A mail is send to the e-mail adress you describe";


    },err=>{console.log(err);this.isLoading=false;
    this.error=err;

    });

   }
   onMailChange(searchValue: any): void {
    //console.log(searchValue.target.value);
    this.email=searchValue.target.value;
    if (this.email.length>7) {
      //console.log(this.email);
      this.isMailValid=false;}else {this.isMailValid=true}
  }
  onPasswordChange(searchValue: any): void {
   // console.log(searchValue.target.value);
    this.password=searchValue.target.value;
    if (this.password.length>4 && this.email.length>7) {
     // console.log(this.email);
      this.isFormValid=false;}else {this.isFormValid=true}
  }
  ngOnInit(): void {

  }

}
/*
 if (this.isLogged) {
      this.isLoading=true;
      const email:string=form.value.email;
      const password:string= form.value.password;

      this.auth.logIn(email,password).subscribe(res=>{
        console.log(res);
        this.isLoading=false;
        this.router.navigate(["/patentList"]);//Carefullll


      },err=>{console.log(err);this.isLoading=false;
      this.error=err;

      });
      form.reset();
    }
    if (!this.isLogged){
      this.isLoading=true;
    const email1:string=form.value.email;
    const password:string= form.value.password;
    this.auth.signUp(email1, password).subscribe(res=>{console.log(res);this.isLoading=false;},err=>{console.log(err);this.isLoading=false;
    this.error=err.error.error.message;
    });

    form.reset();

  }*/
